import { redactedPostHogConfig } from "../lib/redact-personal-data.mjs";
import { captureException, clearUser, enableClientTracing, getTracingContext, setUser } from "./tracing.mjs";
import { ErrorBoundary } from "./react/ErrorBoundary.mjs";

export { ErrorBoundary, captureException, clearUser, enableClientTracing, getTracingContext, redactedPostHogConfig, setUser };